import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { marked } from 'marked';
import Header from '../../components/ui/Header';
import policiesEn from '../../../markdown/POLICIES_en.md?raw';
import policiesAr from '../../../markdown/POLICIES_ar.md?raw';

const PoliciesPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    const parseMarkdown = async () => {
      const activeMd = i18n.language.startsWith('ar') ? policiesAr : policiesEn;
      const parsed = await marked.parse(activeMd);
      setHtmlContent(parsed);
    };
    parseMarkdown();
  }, [i18n.language]);

  return (
    <>
      <Helmet>
        <title>{t('footer.links.privacy')} | {t('hero.name')}</title>
        <meta name="description" content="Privacy Policy and Cookies disclosures for Mohammed Taha [BMT] portfolio and services." />
      </Helmet>

      <div className="min-h-screen bg-background gradient-background">
        <Header />

        <main className="pt-28 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          {/* Decorative glows */}
          <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 bg-accent/5 rounded-full blur-3xl pointer-events-none" />

          <div className="relative bg-card rounded-2xl p-6 md:p-12 border border-border shadow-brand-lg backdrop-blur-sm">
            <div
              className="prose prose-invert max-w-none prose-headings:text-primary prose-p:text-secondary prose-a:text-accent prose-strong:text-primary prose-li:text-secondary"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </div>
        </main>
      </div>
    </>
  );
};

export default PoliciesPage;
